import { render, staticRenderFns } from "./MatchActiveEmpty.vue?vue&type=template&id=259b065b&scoped=true"
import script from "./MatchActiveEmpty.vue?vue&type=script&lang=js"
export * from "./MatchActiveEmpty.vue?vue&type=script&lang=js"
import style0 from "./MatchActiveEmpty.vue?vue&type=style&index=0&id=259b065b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259b065b",
  null
  
)

export default component.exports